type Progress = { current: number; total: number; stage: string };

// experience-backend has no user-data endpoints (nothing to delete there
// yet). This clears the local, in-memory state so the "delete my data" UI
// flow still does something honest, but it is not a real server-side purge.
export const UserService = {
  async deleteAllUserData(
    _userId: string,
    setMoods: (value: unknown[]) => void,
    setCauseTypes: (value: unknown[]) => void,
    refreshData?: () => Promise<void> | void,
    onProgress?: (progress: Progress) => void
  ): Promise<void> {
    console.warn(
      "UserService.deleteAllUserData: experience-backend has no delete endpoint yet; clearing local state only."
    );
    onProgress?.({ current: 0, total: 1, stage: "local-only" });
    setMoods([]);
    setCauseTypes([]);
    await refreshData?.();
    onProgress?.({ current: 1, total: 1, stage: "done" });
  },
};
